import React, {useEffect, useState, useRef, useMemo, useCallback} from 'react';
import {connect} from 'react-redux';
import {setCurrentStep, resetFlowState} from './StreamingRegistrationSlice';
import {createBoundFlowMap, getInitialStep, getInitialScreen, syncRegistrationParamsFromRedirectPage} from './utils/functions';
import {StreamingRegistrationFlowSteps} from './utils/constants';
import SubscriberListPageWrapper from './components/SubscriberListPageWrapper';

const CheckStreamingRegistrationStatusAndRedirectMain = ({
  contentData,
  currentStep,
  setCurrentStep,
  resetFlowState,
}) => {
  const executionLockRef = useRef(null);
  const boundFlowMap = useMemo(() => createBoundFlowMap(contentData, SubscriberListPageWrapper), [contentData]);
  const [activeScreen, setActiveScreen] = useState(null);
  const currentConfig = boundFlowMap[currentStep] ?? null;

  useEffect(() => {
    syncRegistrationParamsFromRedirectPage();
    if (!currentStep) {
      setCurrentStep(getInitialStep());
    }
    return () => resetFlowState();
  }, []);

  useEffect(() => {
    if (!currentConfig?.component || currentConfig.component === activeScreen?.ActiveScreen) {
      return;
    }
    const props = typeof currentConfig.props === 'function' ? currentConfig.props() : currentConfig.props || {};
    setActiveScreen({ActiveScreen: currentConfig.component, props});
  }, [currentConfig]);

  useEffect(() => {
    if (!currentConfig?.executeAction){
      return;
    }
    const nextStep = currentConfig.executeAction();
    if (nextStep) setCurrentStep(nextStep);
  }, [currentStep, boundFlowMap]);

  useEffect(() => {
    if (!currentConfig?.executeAsyncAction || executionLockRef.current === currentStep){
      return;
    }
    executionLockRef.current = currentStep;

    const executeAsync = async () => {
      try {
        const nextStep = await currentConfig.executeAsyncAction();
        executionLockRef.current = null;
        if (nextStep) setCurrentStep(nextStep);
      } catch {
        executionLockRef.current = null;
        setCurrentStep(StreamingRegistrationFlowSteps.ERROR_SCREEN);
      }
    };

    executeAsync();
  }, [currentStep, boundFlowMap]);

  const handleNext = useCallback((args) => {
    const currentConfig = boundFlowMap[currentStep] || {};
    const nextStep = currentConfig?.onSubmit  ? currentConfig.onSubmit (args) : null;
    if (nextStep){
      setCurrentStep(nextStep);
    }
  }, [currentStep, boundFlowMap]);

  const renderActiveScreen = () => {
    if (!activeScreen) {
      const InitialScreen = getInitialScreen();
      return InitialScreen ? <InitialScreen contentData={contentData} onSubmit={handleNext} /> : null;
    }
    const {ActiveScreen, props = {}} = activeScreen;
    return <ActiveScreen contentData={contentData} onSubmit ={handleNext} {...props} />;
  };

  return renderActiveScreen();
};

const mapStateToProps = (state) => ({
  currentStep: state.streamingRegistrationSlice?.currentStep,
});

const mapDispatchToProps = {setCurrentStep, resetFlowState};

export default connect(mapStateToProps, mapDispatchToProps)(CheckStreamingRegistrationStatusAndRedirectMain);
